module.exports = __webpack_public_path__ + "static/media/edit.0b104771.png";